<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('/img/MegaGrantsPoster.png')"
      >
       <video ref="videoRef"  loop="loop" muted="muted" class="video" ></video>
      </parallax>
      
    </div>
    <n-button type="button" class="btn btn-icon btn-round btn-primary" @click="OnMute" style="z-index: 10;position: relative; background-color: transparent; top: -50px; left: 0%;">
      <i v-if="muted" class="now-ui-icons" ><b-icon icon="volume-mute"></b-icon></i>
      <i v-else class="now-ui-icons" ><b-icon icon="volume-down"></b-icon></i>
    </n-button>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title" style="color: white; margin-bottom: 0px;" v-html="$t('neocore.title')"></h2>
            <h6  style="color: white; margin-top: 0;" v-html="$t('neocore.subtitle')"></h6>
            <br/> 
            <h5 class="description" style="color: white; font-size: large;" v-html="joinWithBr($t('neocore.description'))">
             
            </h5>
          </div>
        </div>
        <br><br>
        <div v-if="showSurvey" class="container" style="text-align:center">

        </div>
         <div class="row">
        <div id="feature">
          <div class='column' id="side">
            <h4 class="title" style="color: white;"> {{$t('neocore.features[0].title')}}</h4>
            <p class="description" v-html="joinWithBr($t('neocore.features[0].text'))"/>   
          </div>
          <div class='column' id="main">
             <div class="video-wrapper">
              <video
                src="/img/neocore_use.mp4"
                loop
                muted
                playsinline
                class="small-video"
                style="background-image: url('/img/neocore_use.jpg')"
                ref="featureVideo0"
              >
              </video>
              <button
                v-if="!videoPlaying[0]"
                class="play-btn"
                @click="playFeatureVideo(0)"
              >
                ▶
              </button>
            </div>
            </div>
            
        </div>
        <div id="feature">
          <div class='column' id="side2">
            <h4 class="title" style="color: white;">{{$t('neocore.features[1].title')}}</h4>
            <p class="description" v-html="joinWithBr($t('neocore.features[1].text'))"/>
          </div>
          <div class='column' id="main2">
            <div class="video-wrapper">
              <video
                src="/img/neocore_cost.mp4"
                loop
                muted
                playsinline
                class="small-video"
                style="background-image: url('/img/neocore_cost.jpg')"
                ref="featureVideo1"
              ></video>
              <button
                v-if="!videoPlaying[1]"
                class="play-btn"
                @click="playFeatureVideo(1)"
              >
                ▶
              </button>
            </div>
          </div>
        </div>
        <div id="feature">
          <div class='column' id="side">
            <h4 class="title" style="color: white;">{{$t('neocore.features[2].title')}}</h4>
            <p class="description" v-html="joinWithBr($t('neocore.features[2].text'))"/>
          </div>
          <div class='column' id="main">
            <div class="video-wrapper">
              <video
                src="/img/neocore_markerless.mp4"
                loop
                muted
                playsinline
                class="small-video"
                style="background-image: url('/img/neocore_markerless.jpg')"
                ref="featureVideo2"
              ></video>
              <button
                v-if="!videoPlaying[2]"
                class="play-btn"
                @click="playFeatureVideo(2)"
              >
                ▶
              </button>
            </div>
          </div> 
        </div>
         <div id="feature">
            <div class='column' id="side2">
              <h4 class="title" style="color: white;">{{$t('neocore.features[3].title')}}</h4>
              <p class="description" v-html="joinWithBr($t('neocore.features[3].text'))"/>
            </div>
            <div class='column' id="main2">
             <div class="video-wrapper">
              <video
                src="/img/neocore_multiperson.mp4"
                loop
                muted
                playsinline
                class="small-video"
                style="background-image: url('/img/neocore_multiperson.jpg')"
                ref="featureVideo3"
              ></video>
              <button
                v-if="!videoPlaying[3]"
                class="play-btn"
                @click="playFeatureVideo(3)"
              >
                ▶
              </button>
            </div>
          </div>
        </div>
        <div id="feature">
          <div class='column' id="side">
            <h4 class="title" style="color: white;">{{$t('neocore.features[4].title')}}</h4>
            <p class="description" v-html="joinWithBr($t('neocore.features[4].text'))"/>
          </div>
          <div class='column' id="main">
            <div class="video-wrapper">
              <video
                src="/img/neocoreUELiveLink.mp4"
                loop
                muted
                playsinline
                class="small-video"
                style="background-image: url('/img/neocoreUELiveLink.jpg')"
                ref="featureVideo4"
              ></video>
              <button
                v-if="!videoPlaying[4]"
                class="play-btn"
                @click="playFeatureVideo(4)"
              >
                ▶
              </button>
            </div>
          </div> 
        </div>
        </div>
      </div>
    </div>

  <br><br>
   
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
// import RPGSurvey from '@/components/RPGSurvey.vue'

export default {
  name: 'neocore',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    // RPGSurvey
  },
  mounted() {
      this.$refs.videoRef.src = "/img/NeoCorePromo.mp4";
      this.$refs.videoRef.play();
    
  },
  methods: 
  {

    OnMute()
    {
      this.$refs.videoRef.muted = !this.$refs.videoRef.muted;
      this.$refs.videoRef.play();
      this.muted = this.$refs.videoRef.muted;
    },
    joinWithBr(arr) {
      return Array.isArray(arr) ? arr.join('\n') : arr;
    },
    playFeatureVideo(index) {
      const video = this.$refs[`featureVideo${index}`];
      if (video) {
        video.play();
        this.$set(this.videoPlaying, index, true);
      }
    }
  },
  data() {
    return {
      showSurvey: true,
      expandSurvey: false,
      muted: true,
      form: {
        firstName: '',
        email: '',
        message: ''
      },
      videoPlaying: [false, false, false, false, false], 
    };
  }
};
</script>
<style>
 @import '../assets/scss/redpill.scss';
.small-video {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.3);
  display: block;
  margin: 0 auto;
  background-size: cover; /* Or use 'contain' depending on desired behavior */
  background-position: center center;
  background-repeat: no-repeat;
}
.video-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  
}
.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.6);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 2.5rem;
  width: 64px;
  height: 64px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.play-btn:hover {
  background: rgba(0,0,0,0.8);
}
</style>
